import React from 'react';
import FormNav from '../../components/FormPage/FormNav';
import EmptyForm from '../../components/FormPage/EmptyForm';
import VersionForm from '../FormPage/VersionForm';
import NewVersionForm from '../FormPage/NewVersionForm';
import QueryForm from '../FormPage/QueryBuilder';
import QueryResults from '../FormPage/QueryResults';
import ConnectionCreation from '../FormPage/ConnectionCreation'

export default function FormPage({versions, features, form}) {
    const getForm = (formSelected) => {
        switch(formSelected) {
            case "empty":
                return <EmptyForm />;
            case "versionForm":
                return <VersionForm versions={versions} />;
            case "newVersion":
                return <NewVersionForm features={features} />;
			case "queryBuilder":
				return <QueryForm />;
			case "queryResults":
				return <QueryResults />;
            case "connectionCreation":
                return <ConnectionCreation />;
            default:
                return <EmptyForm />;
        }
    }
    return (
        <div className="min-h-screen flex text-white">
            <FormNav />
            {getForm(form)}
        </div>
    )
}
